/* WILINWORLD PDP — bundle & save, per-item mix & match across designs (popup picker). Draft only. */
(function(){
  function ready(fn){ document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn):fn(); }
  function money(cents){ try{ return '$' + (cents/100).toFixed(2); }catch(e){ return ''; } }
  ready(function(){
    var root = document.querySelector('[data-wds-product]');
    if(!root) return;
    var catalog=[];
    try{ catalog = JSON.parse(root.querySelector('[data-wds-catalog]').textContent); }catch(e){}
    var gmap={};
    try{ gmap = JSON.parse(root.querySelector('[data-wds-garmentmap]').textContent); }catch(e){}
    var byId={}; catalog.forEach(function(p){ byId[p.id]=p; });
    var currentId = parseInt(root.getAttribute('data-wds-current'),10);
    if(!byId[currentId] && catalog[0]) currentId = catalog[0].id;

    var priceEl = root.querySelector('[data-wds-price]');
    var addPrice = root.querySelector('[data-wds-addprice]');
    var addBtn = root.querySelector('[data-wds-add]');
    var qtyIn = root.querySelector('[data-wds-qty]');
    var mainImg = document.getElementById('wdsPdpMain');
    var singleOpts = root.querySelector('[data-wds-single-opts]');
    var packOpts = Array.prototype.slice.call(root.querySelectorAll('[data-wds-bundle] .wds-bundle__opt'));
    var form = root.querySelector('.wds-form') || root.querySelector('[data-wds-form]');
    var dynamicBtn = root.querySelector('[data-wds-dynamic]');
    var modal = root.querySelector('[data-wds-designmodal]');
    var grid = root.querySelector('[data-wds-designgrid]');
    if(singleOpts) singleOpts.hidden = true;

    function def(p){ var v=(p.variants.filter(function(x){return x.avail;}).sort(function(a,b){return a.price-b.price;})[0])||p.variants[0]; return v; }
    var defUnit = def(byId[currentId]).price;
    function optIdx(p,name){ var i=p.optnames.indexOf(name); return i; }
    function garmentIndex(p){ var i=optIdx(p,'Garment'); return i<0?p.optnames.length-1:i; }
    function imgFor(p, color, garment){
      // exact color+garment map first
      var g=(garment||'').trim(), c=(color||'').trim();
      if(p.handle && gmap[p.handle]){
        var key=c+' '+g;
        if(gmap[p.handle][key]) return gmap[p.handle][key];
      }
      // fallback: filename garment match
      if(p.imgs&&p.imgs.length){ var gl=g.toLowerCase(); if(gl){ var hit=p.imgs.filter(function(u){return u.toLowerCase().indexOf(gl)>-1;})[0]; if(hit) return hit; } return p.img||p.imgs[0]; }
      return p.img;
    }
    function rowGarment(row){ var p=rowProduct(row); if(!p) return ''; var gi=garmentIndex(p); var sels=row.querySelectorAll('.wds-bi__sel'); return sels[gi]?sels[gi].value:''; }
    function rowColor(row){ var p=rowProduct(row); if(!p) return ''; var ci=optIdx(p,'Color'); if(ci<0) ci=optIdx(p,'Colour'); if(ci<0) return ''; var sels=row.querySelectorAll('.wds-bi__sel'); return sels[ci]?sels[ci].value:''; }
    function refreshRowThumb(row){ var p=rowProduct(row); if(!p) return; var img=row.querySelector('.wds-bi__design img'); if(img) img.src=imgFor(p, rowColor(row), rowGarment(row)); }

    function activePack(){ return root.querySelector('[data-wds-bundle] .wds-bundle__opt.is-active') || packOpts[0]; }
    function activeBox(){ return activePack().querySelector('[data-wds-items]'); }
    function rowVals(row){ return Array.prototype.slice.call(row.querySelectorAll('.wds-bi__sel')).map(function(s){ return s.value; }); }
    function rowProduct(row){ return byId[parseInt(row.getAttribute('data-pid'),10)]; }
    function resolveRow(row){ var p=rowProduct(row); if(!p) return null; var sels=rowVals(row); return p.variants.find(function(v){ return sels.every(function(val,i){ return v.o[i]===val; }); }); }

    function refreshPacks(){
      packOpts.forEach(function(p){
        var pack=parseInt(p.getAttribute('data-pack'),10)||1, disc=parseInt(p.getAttribute('data-discount'),10)||0;
        var pe=p.querySelector('[data-pack-price]'), we=p.querySelector('[data-pack-was]');
        if(pack<=1){ if(pe) pe.textContent=money(defUnit); if(we) we.textContent=''; }
        else { var full=defUnit*pack; if(pe) pe.textContent=money(Math.max(0,full-disc)); if(we) we.textContent=money(full); }
      });
    }

    function activeTotal(){
      var p=activePack(), disc=parseInt(p.getAttribute('data-discount'),10)||0, box=activeBox(), sum=0;
      if(box){ Array.prototype.slice.call(box.querySelectorAll('.wds-bi__row')).forEach(function(row){ var v=resolveRow(row); if(v) sum+=v.price; }); }
      return Math.max(0, sum-disc);
    }

    function updatePrice(){
      var total=activeTotal();
      if(addPrice) addPrice.textContent=money(total);
      if(priceEl) priceEl.innerHTML=money(total);
      var p=activePack();
      if((parseInt(p.getAttribute('data-pack'),10)||1)>1){
        var disc=parseInt(p.getAttribute('data-discount'),10)||0;
        var pe=p.querySelector('[data-pack-price]'); if(pe) pe.textContent=money(total);
        var we=p.querySelector('[data-pack-was]'); if(we) we.textContent=money(total+disc);
      }
      var box=activeBox();
      if(box && mainImg){ var r0=box.querySelector('.wds-bi__row'); if(r0){ var pr=rowProduct(r0); if(pr && pr.img) mainImg.src=pr.img.split('?')[0]+'?width=1200'; } }
    }

    function buildSelects(row, product, keep){
      var opts=row.querySelector('.wds-bi__opts');
      opts.innerHTML='';
      var base=def(product).o;
      product.optnames.forEach(function(name,i){
        var sel=document.createElement('select'); sel.className='wds-bi__sel'; sel.setAttribute('aria-label',name);
        (product.optvalues[i]||[]).forEach(function(val){ var op=document.createElement('option'); op.value=val; op.textContent=val; sel.appendChild(op); });
        var want=(keep && keep[i] && (product.optvalues[i]||[]).indexOf(keep[i])>-1) ? keep[i] : base[i];
        sel.value=want;
        sel.addEventListener('change', function(){ refreshRowThumb(row); updatePrice(); });
        sel.addEventListener('click', function(ev){ ev.stopPropagation(); });
        opts.appendChild(sel);
      });
    }

    function setRowDesign(row, product, keep){
      row.setAttribute('data-pid', product.id);
      var db=row.querySelector('.wds-bi__design');
      db.querySelector('.wds-bi__dn').textContent = product.title.replace(/^\"|\"$/g,'');
      buildSelects(row, product, keep);
      db.querySelector('img').src = imgFor(product, rowColor(row), rowGarment(row));
    }

    function buildRow(){
      var row=document.createElement('div'); row.className='wds-bi__row';
      var head=document.createElement('div'); head.className='wds-bi__head';
      var n=document.createElement('span'); n.className='wds-bi__n'; head.appendChild(n);
      var db=document.createElement('button'); db.type='button'; db.className='wds-bi__design';
      db.innerHTML='<img alt=""><span class="wds-bi__dn"></span><span class="wds-bi__edit">Change</span>';
      db.addEventListener('click', function(ev){ ev.stopPropagation(); openModal(row); });
      head.appendChild(db); row.appendChild(head);
      var opts=document.createElement('div'); opts.className='wds-bi__opts'; row.appendChild(opts);
      setRowDesign(row, byId[currentId], null);
      return row;
    }

    function renderRows(box, pack){ box.innerHTML=''; for(var i=0;i<pack;i++){ var r=buildRow(); r.querySelector('.wds-bi__n').textContent=(i+1); box.appendChild(r); } }

    function applyPack(){
      packOpts.forEach(function(p){
        var box=p.querySelector('[data-wds-items]'); if(!box) return;
        if(p.classList.contains('is-active')){ var pack=parseInt(p.getAttribute('data-pack'),10)||1; if(!box.querySelector('.wds-bi__row')) renderRows(box,pack); box.hidden=false; }
        else { box.hidden=true; }
      });
      var ap=activePack(); if(qtyIn) qtyIn.value=parseInt(ap.getAttribute('data-pack'),10)||1;
      if(dynamicBtn){ dynamicBtn.style.display = (parseInt(ap.getAttribute('data-pack'),10)||1) > 1 ? 'none' : ''; }
      refreshPacks(); updatePrice();
    }

    // design modal
    var editingRow=null;
    function buildGrid(color, garment){
      if(!grid) return; grid.innerHTML='';
      catalog.forEach(function(p){
        var t=document.createElement('button'); t.type='button'; t.className='wds-design-tile';
        var im=imgFor(p, color, garment);
        t.innerHTML='<img src="'+im+'" alt=""><span>'+p.title.replace(/^\"|\"$/g,'')+'</span>';
        t.addEventListener('click', function(){ if(editingRow){ setRowDesign(editingRow, p, rowVals(editingRow)); updatePrice(); } closeModal(); });
        grid.appendChild(t);
      });
    }
    function openModal(row){ editingRow=row; buildGrid(rowColor(row), rowGarment(row)); if(modal){ modal.hidden=false; document.documentElement.style.overflow='hidden'; } }
    function closeModal(){ if(modal){ modal.hidden=true; document.documentElement.style.overflow=''; } editingRow=null; }
    root.querySelectorAll('[data-wds-design-close]').forEach(function(el){ el.addEventListener('click', closeModal); });

    packOpts.forEach(function(p){
      p.addEventListener('click', function(e){
        if(e.target.closest('[data-wds-items]')) return;
        packOpts.forEach(function(x){ x.classList.remove('is-active'); });
        p.classList.add('is-active'); applyPack();
      });
    });

    root.querySelectorAll('[data-wds-thumb]').forEach(function(t){
      t.addEventListener('click', function(){ if(mainImg){ mainImg.src=t.getAttribute('data-full'); } root.querySelectorAll('[data-wds-thumb]').forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active'); });
    });

    if(form){
      form.addEventListener('submit', function(e){ e.preventDefault();
        var p=activePack(), code=p.getAttribute('data-code')||'', box=activeBox(), counts={};
        if(box){ Array.prototype.slice.call(box.querySelectorAll('.wds-bi__row')).forEach(function(row){ var v=resolveRow(row); if(v) counts[v.id]=(counts[v.id]||0)+1; }); }
        var items=Object.keys(counts).map(function(id){ return {id:parseInt(id,10),quantity:counts[id]}; });
        if(!items.length) return;
        if(addBtn) addBtn.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){ window.location.href = code ? ('/discount/'+code+'?redirect=/cart') : '/cart'; })
          .catch(function(){ if(addBtn) addBtn.disabled=false; });
      });
    }

    applyPack();
  });
})();
